
export default {
  name: "PostContentSections",
  props: {
    sections: Array,
    scrollY: Number
  },
};
